import { RefObject, useEffect } from 'react'
import { localEventByLocalId } from 'services/db/Queries/Event'
import LocalStorage from 'services/LocalStorage'
import Logger from 'services/Logger'
import { EventDoc } from 'types/api/changes'
import { LocalStorageKey } from 'types/services/localStorage'

export function usePendingEventAutoOpen(
  event: EventDoc | undefined,
  instanceStart: number | undefined,
  instanceEnd: number | undefined,
  eventRef: RefObject<HTMLDivElement | null>
) {
  useEffect(() => {
    if (
      !event?.id ||
      event._id?.length !== 0 ||
      event.local_id?.length !== 0 ||
      event._rev === 'copy'
    ) {
      return
    }

    let isMounted = true

    const timeout = setTimeout(() => {
      if (!isMounted) return

      // Rendering can lag behind an in-place save. The live row determines
      // whether this is still a pending event, not the captured render copy.
      void localEventByLocalId(event.id!)
        .then((current) => {
          if (!isMounted) return
          if (
            current?._id?.length === 0 &&
            current.local_id?.length === 0 &&
            current._rev !== 'copy' &&
            current.syncStatus !== 'deleted' &&
            eventRef.current?.isConnected &&
            LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) !== '1' &&
            LocalStorage.get(LocalStorageKey.DRAGGING) !== '1'
          ) {
            eventRef.current.click()
          }
        })
        .catch((error) => {
          Logger.orange('Unable to verify pending event before opening', error)
        })
    }, 50)

    return () => {
      isMounted = false
      clearTimeout(timeout)
    }
  }, [
    event?.id,
    event?._id,
    event?.local_id,
    event?._rev,
    instanceStart,
    instanceEnd,
    eventRef
  ])
}
